module.exports = __webpack_public_path__ + "img/helen-674dae1.jpg";